// extracted by mini-css-extract-plugin
module.exports = {"delete-profile":"DeleteProfile_delete-profile__3FDfx","buttons-container":"DeleteProfile_buttons-container__bHQp3"};